import gsap from 'gsap'
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, Autoplay, Controller, FreeMode } from 'swiper';
//import { content } from '../../tailwind.config';

function bannerSlider(){
	const bannerSwiper = new Swiper('.quotes-slider', {
		// configure Swiper to use modules
		modules: [Navigation, Pagination, Autoplay],
		loop: true,

		autoplay: {
			delay: 5000,
		},

		pagination: {
			el: '.quotes-slider-pagination',
			type: 'bullets',
			clickable: true,
		},
		navigation: {
			nextEl: '.quotes-slider-button-next',
			prevEl: '.quotes-slider-button-prev',
		},
	});
}

function bannerVideoGallerySlider(){
	const imageSlider = new Swiper('.js-banner-video-gallery-slider', {
		modules: [Navigation, Pagination, FreeMode, Autoplay],
		loop: true,
		draggable: true,
		freeMode: {
			enabled: true,
			sticky: false,
		},
		allowTouchMove: true,
		effect: 'slide',
		spaceBetween: 20,
		slidesPerView: 1,
		breakpoints: {
			760: {
				slidesPerView: 1,
				spaceBetween: 20
			},
			992: {
				slidesPerView: 2,
				spaceBetween: 20
			},
		},
		navigation: {
			nextEl: '.js-banner-video-gallery-slider-next',
			prevEl: '.js-banner-video-gallery-slider-prev',
		},
		//watchSlidesVisibility: true,
		//watchSlidesProgress: true,
	});
	
	$('.js-image-slider').find('.swiper-slide-prev').css( 'visibility', 'hidden' );
	
	imageSlider.on('slideChange', function(){
		$('.js-image-slider').find('.swiper-slide').css( 'visibility', '' );
	});



	if ( document.querySelector( '.js-banner-video-gallery-slider' ) ){
		gsap.to( '.js-banner-video-gallery-slider', {
			scrollTrigger: {
				trigger: document.querySelector( '.js-banner-video-gallery-slider' ),
				scrub: 1,
				start: 'top center',
				end: 'bottom top',
				//markers: true,
			},
			x: `-200px`,
			ease: 'none'
		});
	}
}


function radleySlider(){
	if ( document.querySelectorAll( '.js-radley-slider-images' ).length > 0 ) {
		var radleyImg = new Swiper('.js-radley-slider-images', {
			// configure Swiper to use modules
			modules: [Navigation, Autoplay, Controller],
			loop: false,
			draggable: true,
			allowTouchMove: true,
			effect: 'slide',
			spaceBetween: 20,
			slidesPerView: 1,
		});
	}
	if ( document.querySelectorAll( '.js-radley-slider-text' ).length > 0 ) {
		var radleyText = new Swiper('.js-radley-slider-text', {
			modules: [ Autoplay, Controller],
			loop: false,
			draggable: true,
			allowTouchMove: true,
			effect: 'slide',
			spaceBetween: 20,
			slidesPerView: 1,
			slidesPerGroup: 1,
		});
	}

	if ( radleyImg && radleyText ){
		radleyImg.controller.control = radleyText;
		radleyText.controller.control = radleyImg;
	}


	// Function to add zero before numbers below 10
	var helpers = {
		addZeros: function (n) {
			return (n < 10) ? '0' + n : '' + n;
		}
	};

	if ( radleyImg ) {
		radleyImg.on('slideChange', function () {
			document.querySelector('.counter .current').innerHTML = helpers.addZeros(
				radleyImg.activeIndex + 1
			);

			if ( radleyImg.isEnd ){
				radleyImg.el.parentNode.querySelector('.js-radley-slider-next').classList.add('swiper-button-disabled')
			} else {
				radleyImg.el.parentNode.querySelector('.js-radley-slider-next').classList.remove('swiper-button-disabled')
			}
		});
	}


	document.querySelectorAll('.js-radley-slider-next').forEach(nextBtnImg => {
		nextBtnImg.addEventListener('click', () => {
			if ( ! radleyImg.isEnd ) {
				radleyImg.slideNext()
			}
		});
	});



	// Content block on the right position
	function contentBlockOnRightPosition(){
		const contentUp = document.querySelectorAll( '[data-js=block-content-up]' )
	
		if ( window.innerWidth > 699 ){
			contentUp.forEach(content => {
				let sliderImagesHeight = content.parentNode.parentNode.querySelector('.js-radley-slider-images').clientHeight
				let moveUp = content.clientHeight + 100

				if ( moveUp < sliderImagesHeight ) {
					content.style.marginTop = - moveUp + 'px'
				} else {
					content.style.marginTop = - sliderImagesHeight + 'px'
				}
			});
		}
	}

	contentBlockOnRightPosition()

	addEventListener("resize", (event) => {
		setTimeout(() => {
			contentBlockOnRightPosition()
		}, 200);
	});



	// Animate the arrow to show it's a slider
	const arrows = document.querySelectorAll('.block--updates-slider .counter .next img')

	if ( arrows.length > 0 ) {
		arrows.forEach(arrow => {
			let tl = gsap.timeline( { repeat: -1, repeatDelay: 2.5, ease: 'none' } );

			tl.fromTo( arrow, { clipPath: 'inset(0% 100% 0% 0%)' }, { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.5 })
		});
	}
}


function houseSlider(){
	if ( document.querySelectorAll( '.js-house-slider' ).length > 0 ) {
		var houseSlider = new Swiper('.js-house-slider', {
			// configure Swiper to use modules
			modules: [Navigation, Pagination],
			loop: false,
			draggable: true,
			allowTouchMove: true,
			effect: 'slide',
			slidesPerView: 1,
		});
	
		// Function to add zero before numbers below 10
		var helpers = {
			addZeros: function (n) {
				return (n < 10) ? '0' + n : '' + n;
			}
		};
	
		if ( houseSlider ) {
			houseSlider.forEach(slider => {
				slider.el.parentNode.querySelector('.js-house-slider-prev')?.classList.add('swiper-button-disabled')
	
				// Number/counter
				slider.on('slideChange', function () {
					slider.el.querySelector('.counter .current').innerHTML = helpers.addZeros(
						slider.activeIndex + 1
					);
	
					if ( slider.isEnd ){
						slider.el.parentNode.querySelector('.js-house-slider-next')?.classList.add('swiper-button-disabled')
					} else {
						slider.el.parentNode.querySelector('.js-house-slider-next')?.classList.remove('swiper-button-disabled')
					}
					if ( slider.isBeginning ){
						slider.el.parentNode.querySelector('.js-house-slider-prev')?.classList.add('swiper-button-disabled')
					} else {
						slider.el.parentNode.querySelector('.js-house-slider-prev')?.classList.remove('swiper-button-disabled')
					}
				});
	
				// Navigation arrows
				slider.el.querySelectorAll('.js-house-slider-prev').forEach(prevArrow => {
					prevArrow.addEventListener('click', () => {
						if ( ! slider.isBeginning ) {
							slider.slidePrev()
						}
					});
				});
				slider.el.querySelectorAll('.js-house-slider-next').forEach(nextArrow => {
					nextArrow.addEventListener('click', () => {
						if ( ! slider.isEnd ) {
							slider.slideNext()
						}
					});
				});
			});
		}
	}
}


function radleianSocietyNews(){
	const radleianSocietyNewsSwiper = new Swiper('.radleian-news-slider', {
		// configure Swiper to use modules
		modules: [Pagination, Autoplay],
		loop: true,

		autoplay: {
			delay: 5000,
		},

		pagination: {
			el: '.radleian-news-slider-pagination',
			type: 'bullets',
			clickable: true,
		},
	});
}

function homepageDefiningRadley(){
	const definingRadley = new Swiper('.defining-radley-swiper', {
		modules: [Autoplay],
		loop: true,
		draggable: true,
		allowTouchMove: true,
		effect: 'slide',
		spaceBetween: 20,
		slidesPerView: 1,
		slidesPerGroup: 1,

		speed: 900,
		autoplay: {
			delay: 2500,
		},

		breakpoints: {
			520: {
				slidesPerView: 2,
			},
			700: {
				slidesPerView: 2,
				spaceBetween: 40,
			},
			1024: {
				slidesPerView: 2,
				spaceBetween: 80,
			},
		},
	});
}


export { bannerSlider, bannerVideoGallerySlider, radleySlider, houseSlider, radleianSocietyNews, homepageDefiningRadley };
